import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Tooltip, Popover } from 'antd';
import classnames from 'classnames';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { apis, apiHolder as api, reDefinedColorListNew, } from 'api';
import IconCard from '@web-common/components/UI/IconCard/index';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import update from 'immutability-helper';
import { MailClassifyActions, useActions, useAppSelector } from '@web-common/state/createStore';
import listStyle from './classifyList.module.scss';
import { getIn18Text } from 'api';
import { getTreeStatesByAccount } from '@web-mail/util';
import { forbidExecActions } from '../classify-content-modal';
import { isBodyContainsOperator, isBodyExcludesOperator, MAIL_CLASSIFY_BODY_FIELD } from '../operator_utils';
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.api.getSystemApi();
const ClassifyItem = props => {
    var _a, _b, _c, _d, _e;
    const { emailContactMap, data, editRule, getListData, mailBoxs, deleteClassifyItem, _account } = props;
    const isThirdAccount = ((_b = (_a = systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.authAccountType) !== '0';
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [ruleDisabledText, setRuleDisabledText] = useState('');
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const { setShowFolderSelectModal, setIsScopeSent } = useActions(MailClassifyActions);
    const { setFolderExecFun } = useActions(MailClassifyActions);
    const mailTagList = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap, _account);
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList;
        }
        return [];
    }, [mailTreeStateMap, _account]);
    const popClickRef = useRef(null);
    const editorBtnRef = useRef(null);
    const [tagColors, setTagColors] = useState([]);
    const [tagFontColors, setTagFontColors] = useState([]);
    const [actionFail, setActionFail] = useState(false);
    const { actions = [], condictions = [], disabled: unStarted } = data;
    const isScopeSentRule = condictions.some(item => item.field === 'scope' && Array.isArray(item.operand) && item.operand.includes('savesent'));
    const includeBodyCondition = condictions.some(item => item.field === MAIL_CLASSIFY_BODY_FIELD);
    const accounts = condictions.find(item => item.field === 'accounts');
    const from = condictions.filter(item => item.field === 'from' && item.operator === 'contains');
    const fromExcludes = condictions.filter(item => item.field === 'from' && item.operator === 'excludes');
    const recipients = condictions.filter(item => item.field === 'recipients' && item.operator === 'contains');
    const recipientsExcludes = condictions.filter(item => item.field === 'recipients' && item.operator === 'excludes');
    const to = condictions.filter(item => item.field === 'to' && item.operator === 'contains');
    const toExcludes = condictions.filter(item => item.field === 'to' && item.operator === 'excludes');
    const subject = condictions.filter(item => item.field === 'subject' && item.operator === 'contains');
    const subjectExcludes = condictions.filter(item => item.field === 'subject' && item.operator === 'excludes');
    const attachmentName = condictions.filter(item => item.field === 'attachmentName' && item.operator === 'contains');
    const attachmentNameExcludes = condictions.filter(item => item.field === 'attachmentName' && item.operator === 'excludes');
    const cc = condictions.filter(item => item.field === 'cc' && item.operator === 'contains');
    const ccExcludes = condictions.filter(item => item.field === 'cc' && item.operator === 'excludes');
    const body = condictions.filter(item => item.field === MAIL_CLASSIFY_BODY_FIELD && isBodyContainsOperator(item.operator));
    const bodyExcludes = condictions.filter(item => item.field === MAIL_CLASSIFY_BODY_FIELD && isBodyExcludesOperator(item.operator));
    const flagOperatorOr = condictions.some(item => item.flagOperatorOr) ? getIn18Text('HUO') : getIn18Text('QIE');
    const ruleContent = [
        { data: from, title: getIn18Text('FAJIANRENBH'), className: 'contact' },
        { data: fromExcludes, title: getIn18Text('FAJIANRENBBH'), className: 'contact' },
        { data: recipients, title: getIn18Text('[SHOUJIANRENHUO11'), className: 'contact' },
        { data: recipientsExcludes, title: getIn18Text('[SHOUJIANRENHUO'), className: 'contact' },
        { data: to, title: getIn18Text('SHOUJIANRENBH'), className: 'contact' },
        { data: toExcludes, title: getIn18Text('SHOUJIANRENBBH'), className: 'contact' },
        { data: cc, title: getIn18Text('CHAOSONGRENBH'), className: 'contact' },
        { data: ccExcludes, title: getIn18Text('CHAOSONGRENBBH'), className: 'contact' },
        { data: subject, title: getIn18Text('ZHUTIBAOH'), className: 'subject' },
        { data: subjectExcludes, title: getIn18Text('ZHUTIBUBH'), className: 'subject' },
        { data: attachmentName, title: getIn18Text('FUJIANMINGCBH'), className: 'attachmentName' },
        { data: attachmentNameExcludes, title: getIn18Text('FUJIANMINGCBBH'), className: 'attachmentName' },
        { data: body, title: getIn18Text('邮件正文包含'), className: 'body' },
        { data: bodyExcludes, title: getIn18Text('邮件正文不包含'), className: 'body' },
    ]
        .filter(i => i.data.length)
        .reduce((prev, { data, title, className }) => {
        const list = data.map(item => ({ value: item.operand, title, className }));
        return [...prev, ...list];
    }, []);
    const tags = actions.find(item => item.type === 'tags');
    const reply = actions.find(item => item.type === 'reply');
    const flags = actions.find(item => item.type === 'flags');
    const move = actions.find(item => item.type === 'move');
    const forward = actions.find(item => item.type === 'forward');
    const reject = actions.find(item => item.type === 'reject');
    const notice = actions.find(item => item.type === 'notice');
    const rulePhase = [
        {
            data: tags,
            title: getIn18Text('TIANJIABIAOQ'),
            className: 'tag',
            id: 'tags',
        },
        {
            data: forward,
            title: getIn18Text('[ZHUANFADAOQI'),
            className: 'contact',
            id: 'forward',
        },
        {
            data: reply,
            title: getIn18Text('ZIDONGHUIF'),
            className: '',
            id: 'reply',
        },
        {
            data: move,
            title: getIn18Text('YIDONGDAO'),
            className: '',
            id: 'move',
        },
        {
            data: reject,
            title: getIn18Text('JUSHOUgkef2'),
            className: '',
            id: 'reject',
        },
        {
            data: notice,
            title: getIn18Text('ZHONGYAOYOUJTX'),
            className: '',
            id: 'notice',
        },
        {
            data: (_c = flags === null || flags === void 0 ? void 0 : flags.value) === null || _c === void 0 ? void 0 : _c.label0,
            title: getIn18Text('TIANJIAHONGQ'),
            className: '',
            id: 'label0',
        },
        {
            data: (_d = flags === null || flags === void 0 ? void 0 : flags.value) === null || _d === void 0 ? void 0 : _d.read,
            title: getIn18Text('BIAOWEIYID'),
            className: '',
            id: 'read',
        },
        {
            data: (_e = flags === null || flags === void 0 ? void 0 : flags.value) === null || _e === void 0 ? void 0 : _e.top,
            title: getIn18Text('[SHEWEIZHIDING'),
            className: '',
            id: 'top',
        },
    ]
        .filter(i => i.data)
        .map(({ data, title, className, id }) => {
        var _a, _b, _c;
        let res = title;
        if (id === 'move') {
            const targetId = data.target;
            const targetName = (_b = (_a = mailBoxs.find(item => item.entry.mailBoxId === +targetId)) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.mailBoxName;
            res = (React.createElement(React.Fragment, null,
                title,
                targetName));
        }
        if (id === 'forward') {
            const emails = ((data === null || data === void 0 ? void 0 : data.target) || '')
                .split(',')
                .map((s) => s.trim())
                .filter(Boolean);
            const displayText = emails.map((email) => emailContactMap[email] || email).join(', ');
            res = (React.createElement(React.Fragment, null,
                title,
                React.createElement("span", { className: classnames(listStyle.contact) },
                    React.createElement(Tooltip, { title: data === null || data === void 0 ? void 0 : data.target }, displayText))));
        }
        if (id === 'reply') {
            res = (React.createElement(React.Fragment, null,
                title,
                `“${data.content}”`));
        }
        if (id === 'tags') {
            res = (React.createElement(React.Fragment, null,
                title, (_c = data.value) === null || _c === void 0 ? void 0 :
                _c.map((val, index) => (React.createElement("span", { className: classnames(listStyle.tag), style: { color: tagFontColors[index], backgroundColor: tagColors[index] } }, val)))));
        }
        return res;
    });
    useEffect(() => {
        if (move && move.target && mailBoxs.length) {
            const mailBoxsIds = mailBoxs.map(item => item.entry.mailBoxId);
            const targetId = +move.target;
            if (!mailBoxsIds.includes(targetId)) {
                setRuleDisabledText(getIn18Text('JIANCEDAOWENJIAN'));
                setActionFail(true);
            }
            else {
                setRuleDisabledText('');
                setActionFail(false);
            }
        }
    }, [move, mailBoxs]);
    useEffect(() => {
        if (tags && tags.value) {
            const tagNames = mailTagList.map(tag => tag[0]);
            const tagValues = tags.value;
            if (!tagValues.length || !tagValues.every(tag => tagNames.includes(tag))) {
                setRuleDisabledText(getIn18Text('JIANCEDAOBIAOQIAN'));
                setActionFail(true);
                return;
            }
            const fontColors = [];
            const tagColors = tagValues.map((item, idx) => {
                const itemD = mailTagList.find(tag => tag[0] === item);
                const itemDColorNums = itemD ? itemD[1].color : -1;
                const colorNum = reDefinedColorListNew.find(colorNum => colorNum.nums.includes(itemDColorNums));
                fontColors[idx] = colorNum ? colorNum.fontColor : '';
                return colorNum ? colorNum.color : '';
            });
            setTagFontColors(fontColors);
            setTagColors(tagColors);
        }
    }, [tags, mailTagList]);
    const hidePopoverVisible = (e) => {
        const parent = e.target.parentElement;
        let grdParent = null;
        if (parent)
            grdParent = parent.parentElement;
        if (popClickRef.current === grdParent || popClickRef.current === parent)
            return;
        if (editorBtnRef.current === e.target && forward)
            return;
        setPopoverVisible(false);
    };
    useEffect(() => {
        document.body.addEventListener('click', hidePopoverVisible);
        return () => {
            document.body.removeEventListener('click', hidePopoverVisible);
        };
    }, []);
    const disabledRule = e => {
        const res = update(data, { $merge: { disabled: !unStarted } });
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        MailConfApi.editMailClassifyRule([res], _account)
            .then(apiRes => {
            if (apiRes === null || apiRes === void 0 ? void 0 : apiRes.success) {
                getListData();
                setPopoverVisible(false);
            }
            else {
                (apiRes === null || apiRes === void 0 ? void 0 : apiRes.title) && SiriusMessage.error({ content: apiRes.title });
            }
        })
            .catch(() => {
            SiriusMessage.error({ content: getIn18Text('GUIZEBAOCUNSHIBAI') || '操作失败' });
        });
    };
    const effectHistoryMail = e => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        if (includeBodyCondition) {
            SiriusModal.info({
                content: getIn18Text('规则条件中包含邮件正文历史邮件无法执行'),
                okText: getIn18Text('QUEREN'),
                okCancel: false,
            });
            setPopoverVisible(false);
            return;
        }
        setIsScopeSent(isScopeSentRule);
        setShowFolderSelectModal(true);
        setFolderExecFun((checkedKeys) => {
            MailConfApi.effectHistoryMail({ id: data.id, ruleIds: undefined, fids: checkedKeys, _account }).then(res => {
                if (res === null || res === void 0 ? void 0 : res.success) {
                    getListData();
                    setPopoverVisible(false);
                    SiriusMessage.success({ content: getIn18Text('LISHIYOUJIANYI') });
                }
                else {
                    SiriusMessage.error({ content: res === null || res === void 0 ? void 0 : res.title });
                }
            });
        });
    };
    const deleteMailClassifyRule = e => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        setPopoverVisible(false);
        SiriusModal.confirm({
            title: getIn18Text('SHANCHUGUIZEDUI'),
            hideCancel: true,
            okText: getIn18Text('SHANCHU'),
            okButtonProps: { danger: true, type: 'default' },
            onOk: () => {
                deleteClassifyItem();
            },
            onCancel: () => { },
        });
    };
    const clickOperator = e => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        setPopoverVisible(val => !val);
    };
    const editRuleAction = e => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        editRule(data);
    };
    const includeForbitAction = useMemo(() => {
        const { actions } = data;
        let inclu = false;
        (actions || []).forEach((item) => {
            var _a;
            if (forbidExecActions.includes((_a = item) === null || _a === void 0 ? void 0 : _a.type)) {
                inclu = true;
            }
        });
        return inclu;
    }, [data]);
    const operatorContent = (React.createElement("div", { className: classnames(listStyle.operatorPopover) },
        !ruleDisabledText && (React.createElement("div", { className: classnames(listStyle.item), onClick: disabledRule }, unStarted ? getIn18Text('LIJIQIYONG') : getIn18Text('LIJIJINYONG'))),
        !ruleDisabledText && !isThirdAccount && !includeForbitAction && (React.createElement("div", { className: classnames(listStyle.item), onClick: effectHistoryMail }, getIn18Text('ZHIXINGGUIZE'))),
        !ruleDisabledText && React.createElement("div", { className: classnames(listStyle.splitLine) }),
        React.createElement("div", { className: classnames(listStyle.item), ref: editorBtnRef, onClick: editRuleAction }, getIn18Text('BIANJI')),
        React.createElement("div", { className: classnames(listStyle.item), onClick: deleteMailClassifyRule }, getIn18Text('SHANCHU'))));
    return (React.createElement("div", { className: classnames(listStyle.classifyItem) },
        React.createElement("div", { className: classnames(listStyle.move) },
            React.createElement(IconCard, { type: "allipseGroup" })),
        React.createElement("div", { className: classnames(listStyle.content) },
            React.createElement("div", { className: classnames(listStyle.rule) },
                data.userRuleName && (React.createElement("div", { className: classnames(listStyle.ruleNameBar) },
                    React.createElement(Tooltip, { title: data.userRuleName },
                        React.createElement("span", { className: classnames(listStyle.ruleNameText) }, data.userRuleName)))),
                React.createElement("div", { className: classnames(listStyle.ruleMain) },
                    React.createElement("div", { className: classnames(listStyle.ruleContainer) },
                        React.createElement("div", { className: classnames(listStyle.ruleDetail) },
                            React.createElement("div", { className: classnames(listStyle.rulePhase) }, getIn18Text('TIAOJIAN:')),
                            React.createElement("div", { className: classnames(listStyle.ruleContent) }, ruleContent.map((item, index) => (React.createElement("div", { className: classnames(listStyle.ruleItem) },
                                index !== 0 && React.createElement("span", { className: classnames(listStyle.prep) }, flagOperatorOr),
                                React.createElement("div", null, item.title),
                                React.createElement("div", { className: classnames(listStyle.ruleItemContent) },
                                    item.value.map(i => {
                                        const quotes = ['subject', 'attachmentName', MAIL_CLASSIFY_BODY_FIELD].includes(item.className);
                                        const hideTips = !!quotes;
                                        const content = (React.createElement("span", { className: classnames(listStyle[item.className]) },
                                            React.createElement("span", { className: classnames(listStyle.wholeName) },
                                                quotes ? '”' : '',
                                                emailContactMap[i] || i,
                                                quotes ? '”' : '')));
                                        return hideTips ? content : React.createElement(Tooltip, { title: i }, content);
                                    }),
                                    index !== ruleContent.length - 1 && '；'))))))),
                    React.createElement("div", { className: classnames(listStyle.operator) },
                        React.createElement("span", { className: classnames(listStyle.scopeTag) }, getIn18Text(isScopeSentRule ? 'FAXINFENLEIGUIZE' : 'LAIXINFENLEIGUIZE')),
                        unStarted && !ruleDisabledText && React.createElement("span", { className: classnames(listStyle.unstart) }, getIn18Text('WEIQIYONG')),
                        ruleDisabledText && (React.createElement(Tooltip, { title: ruleDisabledText, overlayStyle: { maxWidth: 'fit-content' } },
                            React.createElement("span", { className: classnames(listStyle.unstart, listStyle.unable) },
                                React.createElement("span", { className: classnames(listStyle.iconWord) }, getIn18Text('SHIXIAO')),
                                React.createElement(IconCard, { type: "info", stroke: "#F74F4F", width: "12" })))),
                        React.createElement("span", { className: classnames('dark-svg-invert', listStyle.operatorIcon), onClick: clickOperator, ref: popClickRef },
                            React.createElement(Popover, { content: operatorContent, placement: "bottomRight", visible: popoverVisible, overlayClassName: classnames(listStyle.operatorContent) },
                                React.createElement(IconCard, { type: "more" }))))),
                React.createElement("div", { className: classnames(listStyle.splitLine, listStyle.ruleLine) }),
                React.createElement("div", { className: classnames(listStyle.ruleDetail, listStyle.ruleDetailPhase) },
                    React.createElement("div", { className: classnames(listStyle.rulePhase) }, getIn18Text('ZHIXING:')),
                    actionFail ? (React.createElement("div", null,
                        React.createElement("span", { className: classnames(listStyle.actionFail) },
                            "[",
                            React.createElement(IconCard, { type: "info" }),
                            getIn18Text('ZHIXINGCAOZUOSHI')))) : (React.createElement("div", { className: classnames(listStyle.ruleContent) }, rulePhase.map((item, index) => (React.createElement(React.Fragment, null,
                        item,
                        index !== rulePhase.length - 1 && '；')))))))),
        (unStarted || ruleDisabledText) && React.createElement("div", { className: classnames(listStyle.layer) })));
};
export default ClassifyItem;
